<template>
<div class="bash-box tradition-box">
            <p class="h2-title">{{ indata.FirstTitle }}</p>
             <ul>
                <li v-for="(item, index) in indata.children" :key="index">
                    <img :src="item.icon" alt="">
                    <p class="h3">{{ item.title1 }}</p>
                    <p class="detail">{{ item.title2 }}</p>
                </li>
            </ul> 
        </div>

    
</template>
<style scoped src="../../public/css/drp.css">
</style>
<script>
export default {
  name: "Templates6",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
